define('../app/fukit/behavior/grid.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _  = require('underscore'),
      Mn = require('marionette');

  var GridBehavior = Mn.Behavior.extend({
    onFirstRender: function() {
      this.view.on(
        'add:child',
        _.debounce(function() {
          this.updateFieldWidths();
          this.setNumberOfRowColumns();
        })
      );
      this.updateFieldWidths();
      this.setNumberOfRowColumns();
    },

    getChildren: function() {
      if (!this.view.children) {
        return [];
      }
      return this.view.children.toArray();
    },

    areAllFieldWidthsDefined: function() {
      return _.every(this.getChildren(), function(child) {
        return child.size !== null;
      });
    },

    areNoFieldWidthsDefined: function() {
      return _.every(this.getChildren(), function(child) {
        return child.size === null;
      });
    },

    setNumberOfRowColumns: function() {
      var childrenArray = _.filter(this.getChildren(), function(child) {
        return child.visible === true;
      });

      this.view.size = this.areNoFieldWidthsDefined() ? childrenArray.length : null;
    },

    updateFieldWidths: function() {
      if (this.areAllFieldWidthsDefined()) {
        return;
      }
      if (this.areNoFieldWidthsDefined()) {
        return;
      }

      //prettier-ignore
      var childSizeTotal = 0,
          childrenWithoutSizes = [];

      _.each(
        this.getChildren(),
        function(child, index, childrenArray) {
          if (child.size !== null) {
            childSizeTotal += child.size;
          } else {
            childrenWithoutSizes.push(child);
          }
        },
        this
      );

      //prettier-ignore
      var numberOfColumnsAvailable = (16 - childSizeTotal),
          lastChildWithoutSize     = _.last(childrenWithoutSizes),
          size                     = Math.floor(numberOfColumnsAvailable / childrenWithoutSizes.length);

      _.each(childrenWithoutSizes, function(child) {
        child.size = _.isEqual(lastChildWithoutSize, child)
          ? size + (numberOfColumnsAvailable % childrenWithoutSizes.length)
          : size;
      });
    },
  });

  module.exports = GridBehavior;
});

